// import 'core-js'
// Flexbox
import 'flexibility'
import 'hammerjs'

if (!window.Intl) {
  // console.log('polyfilled Intl')
  require('intl')
  require('intl/locale-data/jsonp/en.js')
}

if (!window.performance) {
  (function () {
    if ('performance' in window === false) {
      window.performance = {}
    }
    Date.now = (Date.now || function () { // thanks IE8
      return new Date().getTime()
    })
    if ('now' in window.performance === false) {
      let nowOffset = Date.now()
      if (performance.timing && performance.timing.navigationStart) {
        nowOffset = performance.timing.navigationStart
      }
      window.performance.now = function now () {
        return Date.now() - nowOffset
      }
    }
  })()
}

if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => {
      for (const registration of registrations) {
        registration.unregister()
      }
    })
    .catch(() => {})
}

// remove old browser notice
window.addEventListener('error', () => {
  const e = document.getElementById('old-browser-notice')
  e && (e.className = '')
})
const oldBrowserEl = document.getElementById('old-browser-notice')
oldBrowserEl.remove()
